import { useTexts } from "@/lib/texts";

const Row = ({ hidden, items }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
        {items.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-2xl italic text-stone-300 sm:text-3xl">
                    {item}
                </span>
                <svg viewBox="0 0 20 20" className="h-3 w-3 text-[#E75C15]" aria-hidden="true">
                    <path d="M10 0L12.5 7.5L20 10L12.5 12.5L10 20L7.5 12.5L0 10L7.5 7.5Z" fill="currentColor" />
                </svg>
            </span>
        ))}
    </div>
);

export const Marquee = () => {
    const texts = useTexts();
    const items = (texts.marquee_items || "")
        .split("\n")
        .map((s) => s.trim())
        .filter(Boolean);

    return (
        <section
            data-testid="marquee-section"
            className="relative overflow-hidden border-y border-[#E75C15]/20 bg-[#1C1917] py-6"
        >
            <div className="marquee-track flex w-max">
                <Row items={items} />
                <Row items={items} hidden />
            </div>
        </section>
    );
};
